import React, { useState } from 'react';
import Layout from './components/Layout/Layout';
import AnalyticsDashboard from './components/Analytics/AnalyticsDashboard';
import MainDashboard from './components/Dashboard/MainDashboard';
import CustomerOverview from './components/CustomerOverview/CustomerOverview';
import ChatbotView from './components/ChatbotDashboard/ChatbotView.jsx';
import RM360ChatbotView from './components/RM360Chatbot';
import InboxDashboard from './components/Dashboard/InboxDashboard';
import AlertsDashboard from './components/Dashboard/AlertsDashboard';
import SubscribersDashboard from './components/Dashboard/SubscribersDashboard';
import ReportsDashboard from './components/Dashboard/ReportsDashboard';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import ForgotPassword from './components/Auth/ForgotPassword';
import PrivateRoute from './components/Auth/PrivateRoute';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  const handleViewChange = (view) => {
    console.log('Changing view to:', view);
    setCurrentView(view);
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  }

  const renderContent = () => {
    switch (currentView) {
      case 'dashboard':
        return <MainDashboard />;
      case 'analytics':
        return <AnalyticsDashboard />;
      case 'customer-overview':
        return <CustomerOverview />;
      case 'chatbot':
        return <ChatbotView />;
      case 'RM360':
        return <RM360ChatbotView />;
      case 'inbox':
        return <InboxDashboard />;
      case 'alerts':
        return <AlertsDashboard />;
      case 'subscribers':
        return <SubscribersDashboard />;
      case 'reports':
        return <ReportsDashboard />;
      default:
        return <MainDashboard />;
    }
  };

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={
          isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />
        } />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Layout onViewChange={handleViewChange}>
              {renderContent()}
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;